import { epicDependencies } from '../../../../store';
import { CmpsSdpPercentPipe } from '../sdp-percent.pipe';

export function sdpPercent(value: number | null): string | null {
    // TODO FIXME. this can be done better
    return epicDependencies.injector
        .get<CmpsSdpPercentPipe>(CmpsSdpPercentPipe)
        ?.transform(value);
}
